import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39bad77a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col sm:flex-row space-y-5 items-center my-6 px-2 w-full" }
const _hoisted_2 = { class: "flex flex-row text-center w-100" }

export function render(_ctx, _cache) {
  const _component_v_pagination = _resolveComponent("v-pagination")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_pagination, {
        modelValue: _ctx.pageNo,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = $event => ((_ctx.pageNo) = $event)),
          _ctx.updateHandler
        ],
        pages: _ctx.totalPages,
        "range-size": 1,
        "active-color": "#EDEDED"
      }, null, 8, ["modelValue", "pages", "onUpdate:modelValue"])
    ])
  ]))
}